let OptionsResident = [
    { "label":"Residente", "value":true },
    { "label":"Non residente", "value":false }
]
export default OptionsResident;